
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('input[type="radio"][data-image-url]').forEach(input => {
    input.addEventListener("change", function () {
      const imageUrl = this.dataset.imageUrl;
      const productCard = this.closest(".card-wrapper"); // Update class if needed

      //console.log("Swatch clicked:", imageUrl);

      if (productCard && imageUrl) {
        const productImg = productCard.querySelector("img");

        if (productImg) {
          productImg.src = imageUrl;
          productImg.setAttribute("data-src", imageUrl);
          productImg.removeAttribute("srcset");
          productImg.removeAttribute("data-srcset");
        }
      }
    });
  });
});

